<template>
    <div v-show="shouldShow" :class="[{ collapsed: collapsed }, 'right-side-panel']">
        <ul class="nav flex-column">
            <div v-for="tab in tabs" :key="tab.id">
                <li class="nav-item" v-if="tab.visible" :class="{ active: tab.active }">
                    <a class="nav-link" href="#" @click.prevent="tab.select">
                        <span :class="['fa', tab.icon, 'fa-xl']"/>
                    </a>
                </li>
            </div>
        </ul>

        <div class="full-height nav-component" style="width: 100%;">
            <div v-for="tab in tabs" :key="tab.id" class="full-height" v-show="selectedTab == tab.id" >
                <div class="full-height" :is="tab.component" @closePanel="close"></div>
            </div>
        </div>

    </div>
</template>

<script>
import InteractionEditor from '../interactions/InteractionEditor.vue';
import ActionItems from '../action-items/ActionItems.vue';
import metricsService from './utils/metrics-service';

export default {
    components: { InteractionEditor, ActionItems },
    data() {
        let self = this;

        let tabs = [{
                    id: "tab-action-items",
                    icon: "fa-list-alt",
                    component: "action-items",
                },
                {
                    id: "tab-interaction",
                    icon: "fa-commenting-o",
                    component: "interaction-editor",
                    get visible() { return (self.can && (self.can.editEmployerInteraction || self.can.editParticipantInteraction)) || false; }
                },
                {
                    id: "tab-close-panel",
                    icon: "fa-angle-double-right",
                    component: "",
                    get visible() {
                      const isExternalPaAndHasItems = self.isPlanAdmin && !self.isInternalUser && self.xItems.length;
                      if (isExternalPaAndHasItems) {
                        return false;
                      }
                      return self.selectedTab ? self.selectedTab !== "tab-close-panel" : false;
                    }
                }];

        tabs.forEach(t => {
            if (t.visible === undefined) t.visible = true;
            t.active = false;
            t.select = () => {
                self.tabs.forEach(t1 => t1.active = false);
                t.active = true;
                self.selectedTab = t.id;
                self.panelManage = 'manual';
                localStorage.setItem("rightPanelSelectedTab", t.id);
            };
        });

        return {
                get selectedTab() {
                    var tabId = localStorage.getItem("rightPanelSelectedTab");
                    if (tabId && _.find(tabs, { id: tabId })) {
                        return tabId;
                    } else {
                        return tabs[0].id;
                    }
                },
                set selectedTab(tabId) {
                    localStorage.setItem("rightPanelSelectedTab", tabId);
                },
                tabs: tabs,
                panelManage: 'auto',
        };
    },
    computed: {
        ...amfx.map("session", "isMsr, isInternalUser, isPlanAdmin"),
        ...amfx.map("actionItems", "xItems"),
        closePanel() { return this.isMsr },
        collapsed() { return this.selectedTab === "tab-close-panel"; },
        shouldShow() {
          const isExternalPaThatHasItems = !this.isInternalUser && this.isPlanAdmin && this.xItems.length;
          if (isExternalPaThatHasItems) {
            return true;
          }
          return this.isInternalUser || this.xItems.length;
        }
    },
    created() {
        if(this.closePanel) this.selectedTab = "tab-close-panel";
        this.autoSetPanel(this.xItems);
    },
    watch: {
        selectedTab(newValue, oldValue) {
            metricsService.stop('right-panel', oldValue, this);
            
            if(newValue != 'tab-close-panel')
                metricsService.start('right-panel', newValue, this);
        },
        closePanel(newValue) {
            if(newValue) this.selectedTab = "tab-close-panel";
        },
        xItems(newValue) {
            this.autoSetPanel(newValue);
        }
    },
    methods: {
        close() {
            this.selectedTab = "tab-close-panel";
        },
        autoSetPanel(xItems) {
            if (this.panelManage === 'auto') {
                if (xItems.length > 0) {
                    this.selectedTab = "tab-action-items";
                } else {
                    this.selectedTab = "tab-close-panel";
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
.right-side-panel {
    margin-top: 0;
    max-width: 25%;
    min-width: 370px;
    display: flex;
    flex-direction: row;
    height: 100%;
    overflow-x: hidden;

    &.collapsed {
        min-width: 0;
    }

    .nav {
        background-color: white;
        border-left: 1px solid #cdcac3;
    }

    .nav-component > div > div {
        border-left: 1px solid #cdcac3;
    }

    .nav-link {
        display: block;
        padding: .5rem 1rem;
    }

    .nav-item.active a span {
        // color: #ed531f;
        color: rgb(3, 145, 197);
        // color: rgb(135, 202, 227);
    }

    .fa {
        color: #8c8983;
        font-weight: 400;
        line-height: 1.75em;
    }
}

.right-side-panel input:focus,
.right-side-panel select:focus,
.right-side-panel textarea:focus {
    box-shadow: inset 0 0 0 2px yellow !important;
}
</style>



// WEBPACK FOOTER //
// src/framework/RightPanel.vue